import React, { useContext } from "react"
import { Link } from "gatsby"

import Image from "./Image"
import Price from "./Price"
// import CheckoutBtn from "./CheckoutBtn"

import styles from "./addtocart.module.scss"
import overlayStyles from "./overlay.module.scss"
import btnStyles from "./checkoutBtn.module.scss"

import { trackEvent } from "../helpers"
import { AppContext } from "./Context"


const AddToCart = props => {

  const {
    image,
    title,
    color,
    size,
    price,
    compareAtPrice,
    setShowAddToCartModal,
  } = props

  const appState = useContext(AppContext)

  const closeModal = () => {
    setShowAddToCartModal(false)
  }

  const handleOverlayClick = e => {
    if (e.target.className.includes("--overlay--"))
      closeModal()
  }

  const handleCheckoutButton = () => {
    trackEvent("ATC Modal", "Click", "Checkout Button")
  }

  return (
    <div
      className={`${overlayStyles.overlay} ${styles.overlay}`}
      role="presentation"
      onClick={handleOverlayClick}
    >
      <div className={styles.container}>
        <button
          className={overlayStyles.closeBtn}
          onClick={closeModal}
          title="Close"
        >Close</button>
        <h2 className={styles.heading}>Added to Cart</h2>
        <div className={styles.content}>
          <Image
            image={image}
            altText={`${title} - ${color}`}
            options={{
              origin: "shopify",
              width: "160",
            }}
            className={styles.image}
          />
          <div className={styles.infoWrapper}>
            <div className={styles.info}>
              <h4 className={styles.title}>{title}</h4>
              <p className={styles.color}>{color}</p>
              <p className={styles.size}>{size}</p>
            </div>
            <p className={styles.price}>
              <Price
                price={price}
                compareAtPrice={compareAtPrice}
              />
            </p>
          </div>
        </div>
        <Link
          to="/cart"
          className={btnStyles.btn}
          onClick={handleCheckoutButton}
        >
          Checkout
          <span className={btnStyles.cartCount}>({appState.cartCount})</span>
        </Link>
        {/*<CheckoutBtn*/}
        {/*  showCartCount={true}*/}
        {/*/>*/}
        <p className={styles.note}>Free Shipping & Unlimited Returns (within US)</p>
      </div>
    </div>
  )
}


export default AddToCart
